import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=b36abcae&scoped=true"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=b36abcae&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36abcae",
  null
  
)

export default component.exports